// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import InitialConfigHeader from '../../../components/InitialConfig/UserInitialConfigHeader'
import StepIntro from '../../../components/InitialConfig/StepIntro'
import AsideMenu from '../../../components/InitialConfig/AsideMenu'
import AppLogoImg from '../../../components/Utils/AppLogoImg'
import Loader from '../../../components/Utils/Loader'
import WorkflowNavigationButtons from '../../../components/InitialConfig/WorkflowNavigationButtons';
import WorkflowIlustration from "../../../components/InitialConfig/WorkflowIlustration";
import FormValidationError from "../../../components/InitialConfig/FormValidationError";
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");
var generalCommonJS = require("../../../js/generalCommon.js")

// Initial config - Battery
const Battery = () => {

  const [selectedLocation, setSelectedLocation] = useState([{ id: "", distance: "", lat: "40.4167754", long: "-3.7037902" }]) //Default Madrid

  useEffect(() => {      
    
    if(initialConfigCommonJS.antiBackOnboarding() === false){

      if(localStorage.getItem("installationConfigurationMode") === null){
        localStorage.removeItem("currentInstallationConfiguration")
        localStorage.removeItem("configuredApps")
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - BATERÍAS', "", "")
      }

      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("BATTERY")
      
      if(localStorage.getItem("currentInstallationConfiguration") !== null){        
        procesarConfiguracionActual(JSON.parse(localStorage.getItem("currentInstallationConfiguration")))
      }
      else{
        cargarConfiguracionActualPaso()        
      }

      if(localStorage.getItem("installationConfigurationMode") !== null){
        document.getElementById("batteries").className = "step"
        initialConfigCommonJS.visibilidadModoConfiguracion()
        document.getElementById("initialConfigBreadcrumb").className = document.getElementById("initialConfigBreadcrumb").className.replaceAll(" hidden", "") + " hidden"        

      }   
      else{
        document.title = "HELIAS - Configuración inicial: Baterías"
      }
    }
    
  }, []);

  const [appSensorBaterias, setAppSensorBaterias] = useState("")
  const [appSensorTemperaturaBaterias, setAppSensorTemperaturaBaterias] = useState("")
  const [illustrationElements, setIllustrationElements] = useState([])

  function procesarConfiguracionActual(jsonRespuesta){

    if(jsonRespuesta.Battery.toString().length > 0 ){ 
            
      var configuracionPasoActual = jsonRespuesta.Battery                                        

      //Cargo la combo del sensor de las baterías
      if(configuracionPasoActual.BatteriesSensor !== ""){
        var datosSensorBaterias = configuracionPasoActual.BatteriesSensor.split("|")
        setAppSensorBaterias(datosSensorBaterias[0]) 
        document.getElementById("sensorBateriasSpan").innerHTML = datosSensorBaterias[datosSensorBaterias.length-1]
        document.getElementById("sensorBaterias").value = datosSensorBaterias[0]+"|"+datosSensorBaterias[1]+"|"+datosSensorBaterias[2]
        document.getElementById("sensorBateriasFieldsetSinConfigurar").style="display: none"
        document.getElementById("sensorBateriasFieldsetSeleccionado").style="display"
      }

      document.getElementById("potenciaMaximaInversor").value = configuracionPasoActual.BatteriesInverterMaxPower                          
      document.getElementById("capacidadTotalBaterias").value = configuracionPasoActual.BatteriesMaxCapacity                         
      
      document.getElementById("botonEliminarConfiguracion").className = document.getElementById("botonEliminarConfiguracion").className.replaceAll(" hidden", "")
                  
    }
    
    setIllustrationElements(initialConfigCommonJS.cargaInicialIlustracion(jsonRespuesta))

    //Si no hay datos configurados entonces no hago nada
 
  }

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,    
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{             
            procesarConfiguracionActual(jsonRespuesta.body)
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }
  
  function validacionCamposCorrecta(){

    var numeroErroresValidacion = 0

    document.getElementById("sensorBaterias").className = "link"    
    document.getElementById("potenciaMaximaInversor").className = ""              
    document.getElementById("capacidadTotalBaterias").className = ""      
    
    if(document.getElementById("sensorBaterias").value === ""){
      numeroErroresValidacion++
      document.getElementById("sensorBateriasLink").className += " error"
    }

    if(document.getElementById("potenciaMaximaInversor").value === ""){
      numeroErroresValidacion++
      document.getElementById("potenciaMaximaInversor").className = "error"
    }

    if(document.getElementById("capacidadTotalBaterias").value === ""){
      numeroErroresValidacion++
      document.getElementById("capacidadTotalBaterias").className = "error"
    }
   
    if(numeroErroresValidacion > 0){      
      document.getElementById("divErrorValidacionFormulario").className="message error left"
      return false
    }
    else{
      document.getElementById("divErrorValidacionFormulario").className="message error left hidden"
      return true
    }

  }

  function guardarInformacionPaso(direccion){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
  
    document.getElementById("loaderBattery").className="loader overlay"

    var sensorBaterias = document.getElementById("sensorBaterias").value+"|"+document.getElementById("sensorBateriasSpan").innerHTML
    
    var jsonBattery = {
      "BatteriesAvailable": "true",
      "BatteriesSensor": sensorBaterias,
      "BatteriesInverterMaxPower": document.getElementById("potenciaMaximaInversor").value.replaceAll(",","."),            
      "BatteriesMaxCapacity": document.getElementById("capacidadTotalBaterias").value.replaceAll(",","."),
      "BatteriesOptimunTemperature": "20",
      "BatteriesLocationConstantTemperature": "",
      "BatteriesTemperatureSensor": "AEMET"
    }
  
    var jsonGuardado = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "Battery": jsonBattery
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", updateInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonGuardado);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuestaGuardado = JSON.parse(this.responseText)
          if(jsonRespuestaGuardado.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            console.log("Información guardada correctamente")
            
            if(localStorage.getItem("installationConfigurationMode") === null){
              if(localStorage.getItem("ongoingStepConfiguration") === "BATTERY" ){      
                initialConfigCommonJS.navegarDinamico(direccion)
              }
              else{
                initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
              }
            }
            else{
              initialConfigCommonJS.mostrarMensajeInformativo("Configuración guardada correctamente, estoy conectándome a los sistemas configurados así que puede que los cambios tarden un par de minutos en reflejarse.","positive")
              document.getElementById("asideDetalleConfiguracion").className += " hidden"
              document.getElementById("loaderBattery").className="loader hidden"
            }
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);    

  }
  
  function navegar(direccion){      
    if(initialConfigCommonJS.existeSesion()){
      if(direccion === "continuar"){
        if(validacionCamposCorrecta()){
          if(document.getElementById("contenedorPrincipalOpcion") !== null){
            document.getElementById("contenedorPrincipalOpcion").scrollTop = 0
          }
          guardarInformacionPaso(direccion)
        }
      }            
      else{
        if(localStorage.getItem("ongoingStepConfiguration") === "BATTERY"){      
          initialConfigCommonJS.navegarDinamico(direccion)
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
        }
      }
    }
  }

  return (          
    <main id="divMainContenedorStep">      

      <InitialConfigHeader step={"BATTERY"}/>

      <section id="batteries" className="step wrapper">
        <div id="divContenedorStep" className="content-wrapper half">
          
          <StepIntro 
            Title="Baterías" 
            Intro={<><p>Para exprimir al máximo su rendimiento, necesito que me orientes un poco con unos datos básicos para usar de referencia.</p></>}
          />   

          <form onSubmit={e => { e.preventDefault(); }} autoComplete="off">
          <fieldset>

            <fieldset className="two-columns tooltip-parent">
              <fieldset>                
                <label className="has-tooltip" htmlFor="labelPotenciaMaximaInversor">
                  <span className="label tooltip-label">Potencia máxima del inversor</span>
                  <span className="tooltip-trigger">
                    <span className="material-icon tooltip-icon link size-s">info</span>
                    <span className="tooltip bottom">
                      <span className="tooltip-container">
                        <p className="size-m tooltip-title">¿Cuál es la potencia máxima de tu inversor-cargador?</p>
                        <p className="size-s">Puedes verlo <strong>en tu factura o en el apartado técnico del manual de tu aparato, suele venir indicado en kW</strong>. Aun así si tienes dudas siempre puedes preguntarle a tu instalador.</p>                        
                      </span>
                    </span>
                  </span>
                </label>       
                <fieldset className="icon-wrapper data" data-label="kW">
                  <input type="text" inputMode="decimal" id="potenciaMaximaInversor"/>
                </fieldset>
              </fieldset>

              <fieldset id="capacidadTotalBateriasFieldset">
                <label className="has-tooltip" htmlFor="labelCapacidadTotalBaterias">
                  <span className="label tooltip-label">Capacidad total de las baterías</span>
                  <span className="tooltip-trigger">
                    <span className="material-icon tooltip-icon link size-s">info</span>
                    <span className="tooltip bottom">
                      <span className="tooltip-container">
                        <p className="size-m tooltip-title">¿Cuál es la capacidad de tus baterías?</p>
                        <p className="size-s">Puedes verlo <strong>en tu factura o en el apartado técnico del manual de tus baterías, suele venir indicado en kW</strong>. Aun así si tienes dudas siempre puedes preguntarle a tu instalador.</p>                        
                      </span>
                    </span>
                  </span>
                </label>      
                <fieldset className="icon-wrapper data" data-label="kWh">
                  <input type="text" inputMode="decimal" id="capacidadTotalBaterias"/>
                </fieldset>              
              </fieldset>
            </fieldset>

            <fieldset id="sensorBateriasFieldsetSinConfigurar">              
              <span className="size-l">Monitor de las baterías</span>
              <p id="textoIntroMonitorBaterias">Aquí debes configurar tu inversor o medidor de tus baterías.</p>
              <button id="sensorBateriasLink" className="link" onClick={() => initialConfigCommonJS.configurarDispositivo("sensorBaterias")}><span className="material-icon">add_circle</span>Seleccionar dispositivo</button>
            </fieldset>

            <fieldset id="sensorBateriasFieldsetSeleccionado" style={{display: "none"}}>
              <span className="size-l">Monitor de medición baterías</span>
              <div className="selector icon-wrapper no-icon" >
                <div className="horizontal vertical-center gap-04 fill" onClick={() => initialConfigCommonJS.configurarDispositivo("sensorBaterias")}>
                  <figure className="avatar size-m"><AppLogoImg id="sensorBateriasLogoApp" aplicacion={appSensorBaterias}/></figure>
                  <span id="sensorBateriasSpan" className="label"></span>
                </div>
                <input type="text" id="sensorBaterias" style={{display: "none"}}/>
              </div>
            </fieldset>

          </fieldset>

          </form>

          <FormValidationError/>

          <WorkflowNavigationButtons step={"BATTERY"} navegar={navegar}/>

        </div>

        { localStorage.getItem("installationConfigurationMode") === null
          ? <WorkflowIlustration illustrationElements={illustrationElements}/>
          : <></>
        }

        <Loader Id="loaderBattery" Mensaje=""/>

      </section>

      <AsideMenu selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}/>

    </main>
    
  )
}

export default Battery